import { useOutletContext } from 'react-router-dom';

// components
import ChecklistHeader from '../../../../pages/checklist-page/components/checklist-header/ChecklistHeader';

export default function FriendListDisplay() {
  const context = useOutletContext();
  const { viewingUserID } = context || {};
  return <ChecklistHeader viewingUserID={viewingUserID} />;
}

